import React, { useMemo } from "react";
import { Stack, Box, Typography, Card, CardContent, Avatar } from "@mui/material";
import CustomCarousel from "../../components/customCarousal"; // Adjust the import path as needed

const UserOverview = ({ userOverview, isMobile }) => {
    const columns = useMemo(() => [
        {
            field: 'level',
            headerName: 'Name',
            flex:1,
            // width: 150,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 1 }}>
                    <Avatar
                        src={params.row.img || "/placeholder-avatar.png"}
                        sx={{ width: 25, height: 25 }}
                    />
                    <Typography pl={3}>{params.value}</Typography>


                </Box>
            ),
        },
        {
            field: 'count',
            headerName: 'Point Earned',            
            align: 'center',
            width: 150,
        },
        {
            field: 'pointsAssigned',
            headerName: 'Point Assigned ',
            width: 160,
            align: 'center',
            renderCell: (params) => params.value !== undefined ? params.value : "-",
        },
        {
            field: 'department',
            headerName: 'Department',
            width: 200,
            renderCell: (params) => params.value || "-",
        },
        {
            field: 'designation',
            headerName: 'Designation',
            width: 200,
            renderCell: (params) => params.value || "-",
        },
        
    ], []);
    return (
        <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mt: 4, marginRight: 2, marginBottom: 2 }}>
            <Card sx={{ flex: 1, borderRadius: 3, boxShadow: 2, backgroundColor: "background.main" }}>
                <CardContent>

                {userOverview?.length ? (
                    <CustomCarousel
                        columns={columns}
                        title={'User Overview'}
                        data={userOverview.map((item) => ({
                            level: item.fullName,
                            img: item.userImage,
                            count: item.pointsEarned,
                            department: item.department,
                            designation: item.designation,
                            pointsAssigned: item.pointsAssigned,
                        }))}
                    />
                ) : (
                    <Typography variant="body" color="text.secondary">
                        Loading or no data...
                    </Typography>
                )}
            </CardContent>
        </Card>
    </Stack>
    )
};

export default UserOverview;
